import { render, staticRenderFns } from "./stockY30.vue?vue&type=template&id=2a0f9e34&scoped=true&"
import script from "./stockY30.vue?vue&type=script&lang=js&"
export * from "./stockY30.vue?vue&type=script&lang=js&"
import style0 from "./stockY30.vue?vue&type=style&index=0&id=2a0f9e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0f9e34",
  null
  
)

export default component.exports